var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f25022",
    d: "M1 1h9v9H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a4ef",
    d: "M1 11h9v9H1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fba00",
    d: "M11 1h9v9h-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb900",
    d: "M11 11h9v9h-9z"
  })));
};
export default SvgMicrosoft;